import React from "react";
import { Permissions } from "../../../util/Permissions";
import { SubHeader } from "../../Common/layout/SubHeader";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { TransactionTable } from "./TransactionTable"

export const TransactionManagement = (
    {
        match: {
            params: { userGroup },
        },
    }
) => {
    return (
        <>
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"All"} to={`/transactions/${userGroup}/all`} />
                    <SubHeader.NavItem label={"Pending"} to={`/transactions/${userGroup}/pending`} />
                    <SubHeader.NavItem label={"Transfer In"} to={`/transactions/${userGroup}/transfer-in`} />
                    <SubHeader.NavItem label={"Transfer Out"} to={`/transactions/${userGroup}/transfer-out`} />
                </SubHeader.Nav>
            </SubHeader>
            <div className="py-4 px-6">
                <Switch>
                    <Redirect exact={true} from="/transactions/:userGroup" to="/transactions/:userGroup/all" />

                    <ContentRoute path="/transactions/:userGroup/all" permission={Permissions.TRANSACTIONS}>
                        <TransactionTable userGroup={userGroup} category={"all"} />
                    </ContentRoute>
                    <ContentRoute path="/transactions/:userGroup/pending" permission={Permissions.TRANSACTIONS}>
                        <TransactionTable userGroup={userGroup} category={"pending-transaction"} />
                    </ContentRoute>
                    <ContentRoute path="/transactions/:userGroup/transfer-in" permission={Permissions.TRANSACTIONS}>
                        <TransactionTable userGroup={userGroup} category={"transfer-in"} />
                    </ContentRoute>
                    <ContentRoute path="/transactions/:userGroup/transfer-out" permission={Permissions.TRANSACTIONS}>
                        <TransactionTable userGroup={userGroup} category={"transfer-out"} />
                    </ContentRoute>
                </Switch>
            </div>
        </>
    );
};
